import { SDK_RETRY_BASE_MS, SDK_RETRY_CAP_MS } from '@repo/config';

export function getRetryDelayMs(attemptIndex: number): number {
  return Math.random() * Math.min(SDK_RETRY_BASE_MS * 2 ** attemptIndex, SDK_RETRY_CAP_MS);
}
